import Request from '~/providers/Request';

export const fetchUsaCities = async (input, page, resolve, country = 2) => {
  await Request.get('/admin/cities', {
  sort: 'name',
  direction: 'asc',
  qs: input,
  page: page, 
  country_id: country
}).then(resp => {
    const items = resp.data.map( e => ({
      id: Number(e.id),
      name: `${e.name}`
    }));
    resolve(
      {
        total_count: resp.meta.total,
        items
      }
    );
  });
};